import { createFileRoute } from "@tanstack/react-router"
import { PublicInfoPage } from "@/components/PublicInfoPage"

export const Route = createFileRoute("/delete-account")({
  component: DeleteAccountPage,
})

function DeleteAccountPage() {
  return (
    <PublicInfoPage eyebrow="Wild Guess" title="Delete Account">
      <p>
        Wild Guess Trivia is operated by Club West Creative LLC. You can request
        deletion of your Wild Guess account and associated app data from inside
        the mobile app or from this page.
      </p>

      <h2>Delete From The App</h2>
      <p>
        In the Wild Guess mobile app, open Profile, then Settings, then choose
        Delete account. This removes the Wild Guess account connected to the
        signed-in player.
      </p>

      <h2>Request Deletion By Email</h2>
      <p>
        If you cannot access the app, email{" "}
        <a href="mailto:henry@clubwestcreative.com?subject=Wild%20Guess%20account%20deletion%20request">
          henry@clubwestcreative.com
        </a>{" "}
        with the phone number or email address used for your Wild Guess account.
        We may ask for enough information to verify ownership before deleting
        the account.
      </p>

      <h2>What Gets Deleted</h2>
      <p>
        Account details, player profile information, game activity, rewards
        balances, and other app data associated with the account are deleted
        unless retention is required for security, fraud prevention, legal
        compliance, or operational records.
      </p>
    </PublicInfoPage>
  )
}
